import React from "react";

interface GeneralInfoProps {
  modelDetail: any;
}

export const GeneralInfoTab: React.FC<GeneralInfoProps> = ({ modelDetail }) => {
  if (!modelDetail) return null;

  const infoItems = [
    {
      label: "Model Name",
      value: modelDetail?.result?.meterModel || "NA",
    },
    {
      label: "Make Code",
      value: modelDetail?.result?.meterMake || "NA",
    },
    {
      label: "Manufacturer",
      value: modelDetail?.result?.meterManufacturer?.name || "NA",
    },
    {
      label: "Resource Type",
      value: modelDetail?.result?.resourceTypeDisplay || "NA",
    },
    {
      label: "Resource Sub Type",
      value: modelDetail?.result?.resourceSubtypeDisplay || "NA",
    },
    {
      label: "Created",
      value: modelDetail?.result?.createdDate
        || "NA",
    },
  ];

  return (
    <div className="bg-white p-6 rounded-xl border border-gray-150 shadow-sm space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {infoItems.map((item, idx) => (
          <div key={idx}>
            <span className="text-xs text-gray-400 block font-semibold mb-1">
              {item.label}
            </span>
            <span className="text-sm font-semibold text-gray-800">
              {item.value}
            </span>
          </div>
        ))}
      </div>

      <div className="border-t border-gray-100 pt-6">
        <span className="text-xs text-gray-400 block font-semibold mb-1">
          Description
        </span>
        <p className="text-sm text-gray-600 max-w-2xl leading-relaxed">
          {modelDetail?.result?.description || "No description provided."}
        </p>
      </div>

      {modelDetail?.result?.utilityService && (
        <div className="border-t border-gray-100 pt-6">
          <span className="text-xs text-gray-400 block font-semibold mb-1">
            Utility Services
          </span>
          <div className="flex flex-wrap gap-2 mt-1">
            <span className="px-3 py-1 rounded bg-blue-50 text-blue-700 border border-blue-100 text-xs font-bold">
              {modelDetail?.result?.utilityService}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeneralInfoTab;
